import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './TravelServices.css';
import hotelImg from "../assets/Services/journey.png";

class TravelServices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      leftServices: [
        { id: 1, title: 'World Tours', desc: 'Explore our tour packages and also reliable', icon: 'bi-globe', theme: 'blue' },
        { id: 2, title: 'Best Hotels', desc: 'Top-rated hotels, premium comfort.', icon: 'bi-building', theme: 'green' },
        { id: 3, title: 'Cheap Packages', desc: 'Affordable packages, best value for money.', icon: 'bi-ticket-perforated', theme: 'orange' }
      ],
      rightServices: [
        { id: 4, title: 'Travel Guides', desc: 'Expert travel tips for a hassle-free journey.', icon: 'bi-book', theme: 'purple' },
        { id: 5, title: 'Location Manager', desc: 'Find top locations and plan with ease.', icon: 'bi-geo-alt', theme: 'yellow' },
        { id: 6, title: 'Best Travel Agents', desc: 'Expert agents here to help, 24/7.', icon: 'bi-people', theme: 'pink' }
      ]
    };
  }

  render() {
    const { leftServices, rightServices } = this.state;

    return (
      <section className="travel-services-section container py-5">
        
        <div className="text-center mb-5">
          <h2 className="services-title">Providing The Best Quality Services</h2>
          <div className="services-subtitle-wrapper">
            <span className="services-subtitle">In Travel</span>
            <svg className="subtitle-underline" viewBox="0 0 200 20" xmlns="http://www.w3.org/2000/svg">
              <path d="M5,15 Q100,5 195,15" fill="none" stroke="#1E65E2" strokeWidth="3" strokeLinecap="round"/>
            </svg>
          </div>
        </div>

        <div className="row g-4 align-items-stretch">
          <div className="col-lg-4 d-flex flex-column justify-content-between gap-3">
            {leftServices.map(service => (
              <div className={`service-card theme-${service.theme} d-flex align-items-center`} key={service.id}>
                <div className="service-icon-wrapper">
                  <i className={`bi ${service.icon}`}></i>
                </div>
                <div className="service-info">
                  <h4 className="service-name">{service.title}</h4>
                  <p className="service-desc">{service.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="col-lg-4">
          <img src={hotelImg} alt="Hotel" /></div>
          <div className="col-lg-4 d-flex flex-column justify-content-between gap-3">
            {rightServices.map(service => (
              <div className={`service-card theme-${service.theme} d-flex align-items-center`} key={service.id}>
                <div className="service-icon-wrapper">
                  <i className={`bi ${service.icon}`}></i>
                </div>
                <div className="service-info">
                  <h4 className="service-name">{service.title}</h4>
                  <p className="service-desc">{service.desc}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
    );
  }
}

export default TravelServices;

